module.exports = __webpack_public_path__ + "static/media/jpg-simple-icon.49d1e90f.svg";